import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.998 15.927a3.429 3.429 0 100-6.858 3.429 3.429 0 000 6.857z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.09 10.185l-.24-.257c-1.937-2.092-5.537-6-10.85-6-5.315 0-8.915 3.908-10.852 6l-.24.257a3.428 3.428 0 000 4.628l.24.258c1.937 2.091 5.537 6 10.851 6 5.314 0 8.914-3.909 10.852-6l.24-.258a3.429 3.429 0 000-4.628zm-2.81 2.606c-2.23 2.4-4.852 4.851-8.28 4.851-3.43 0-6.052-2.451-8.28-4.851a.429.429 0 010-.583C5.981 9.773 8.57 7.356 12 7.356c3.428 0 6.016 2.417 8.28 4.852a.429.429 0 010 .583z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
